/**
 * Consistent axes / grids for Recharts in light vs dark shells.
 */
export function getDashboardChartTokens(isDark) {
  return {
    axis: isDark ? '#94a3b8' : '#64748b',
    muted: isDark ? 'rgba(148,163,184,0.35)' : 'rgba(100,116,139,0.25)',
    tooltipBg: isDark ? 'rgba(15,23,42,0.94)' : 'rgba(255,255,255,0.96)',
    tooltipBorder: isDark ? 'rgba(148,163,184,0.35)' : 'rgba(226,232,240,0.95)',
    tooltipFg: isDark ? '#f1f5f9' : '#0f172a',
    barGradientStart: isDark ? '#f87171' : '#dc2626',
    barGradientEnd: isDark ? '#ef4444' : '#991b1b',
    line: isDark ? '#a78bfa' : '#7c3aed',
  };
}
